import { BasePluginConfig, ReportData } from './types';

export abstract class BasePlugin {
  protected config: BasePluginConfig = {};
  public report?: (data: ReportData) => void;

  public abstract name: string;

  public setConfig(config: BasePluginConfig): void {
    this.config = { ...this.config, ...config };
  }

  public setReport(report: (data: ReportData) => void): void {
    this.report = report;
  }

  public abstract init(): void;
  public abstract destroy(): void;
} 